import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=c51af660&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=c51af660&prod&lang=scss&scoped=true"
import style1 from "./style/h5_pageFooter.scss?vue&type=style&index=1&id=c51af660&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51af660",
  null
  
)

export default component.exports